module.exports = __webpack_public_path__ + "img/icon-calendar.ae183cb6.svg";